export const loginTranslations = {
  en: {
    'login.backToHome': 'Back to Home',
    'login.usernameOrEmailRequired': 'Username or email is required',
    'login.passwordRequired': 'Password is required',
    'login.loginFailed': 'Login failed',
    'login.invalidCredentials': 'Invalid username/email or password',
    'login.networkError': 'Unable to connect to server. Please check your connection and try again.',
    'login.timeout': 'Login request timed out. Please try again.',
    'login.serverError': 'Server error occurred. Please try again later.',
    'login.noToken': 'No authentication token received from server',
    'login.guestLoginFailed': 'Guest login failed',
    'login.guestLoginTimeout': 'The server took too long to respond. Please try again.',
    'login.guestLoginNetworkError': 'Cannot connect to server. Please check if the backend is running.',
    'login.guestLoginUnauthorized': 'Guest login is not authorized. Check API key configuration.',
    'login.guestLoginNotFound': 'Guest login endpoint not found. Backend may need updating.',
    'login.otpLoginFailed': 'Login failed after OTP verification',
    'login.hidePassword': 'Hide password',
    'login.showPassword': 'Show password',
    'login.no_account_question': 'Don\'t have an account?',
    'login.with_phone': 'Sign in with Phone or Email',
    'login.with_biometric': 'Sign in with biometric',
    'login.provide_email': 'Please provide an email',
    'login.provide_pass': 'Please provide a password',
    'login.input_placeholder': 'Enter username, email, or phone',
  },
  es: {
    'login.backToHome': 'Volver al Inicio',
    'login.usernameOrEmailRequired': 'Se requiere nombre de usuario o correo electrónico',
    'login.passwordRequired': 'Se requiere contraseña',
    'login.loginFailed': 'Falló el inicio de sesión',
    'login.invalidCredentials': 'Nombre de usuario/correo electrónico o contraseña no válidos',
    'login.networkError': 'No se puede conectar al servidor. Por favor, compruebe su conexión e inténtelo de nuevo.',
    'login.timeout': 'La solicitud de inicio de sesión ha caducado. Por favor, inténtelo de nuevo.',
    'login.serverError': 'Se ha producido un error en el servidor. Por favor, inténtelo de nuevo más tarde.',
    'login.noToken': 'No se ha recibido ningún token de autenticación del servidor',
    'login.guestLoginFailed': 'Falló el inicio de sesión de invitado',
    'login.guestLoginTimeout': 'El servidor tardó demasiado en responder. Por favor, inténtelo de nuevo.',
    'login.guestLoginNetworkError': 'No se puede conectar al servidor. Por favor, compruebe si el backend se está ejecutando.',
    'login.guestLoginUnauthorized': 'El inicio de sesión de invitado no está autorizado. Compruebe la configuración de la clave de la API.',
    'login.guestLoginNotFound': 'No se ha encontrado el punto final de inicio de sesión de invitado. Es posible que el backend necesite una actualización.',
    'login.otpLoginFailed': 'Falló el inicio de sesión después de la verificación de OTP',
    'login.hidePassword': 'Ocultar contraseña',
    'login.showPassword': 'Mostrar contraseña',
    'login.no_account_question': '¿No tienes una cuenta?',
    'login.with_phone': 'Iniciar sesión con el teléfono',
    'login.with_biometric': 'Iniciar sesión con biométrica',
    'login.provide_email': 'Por favor proporciona un email',
    'login.provide_pass': 'Por favor proporciona una contraseña',
    'login.input_placeholder': 'Introduce nombre de usuario, email o teléfono',
  },
  sr: {
    'login.backToHome': 'Назад на почетну',
    'login.usernameOrEmailRequired': 'Корисничко име или имејл је обавезно',
    'login.passwordRequired': 'Лозинка је обавезна',
    'login.loginFailed': 'Пријављивање неуспешно',
    'login.invalidCredentials': 'Неважеће корисничко име/имејл или лозинка',
    'login.networkError': 'Није могуће повезати се са сервером. Проверите везу и покушајте поново.',
    'login.timeout': 'Захтев за пријављивање је истекао. Покушајте поново.',
    'login.serverError': 'Догодила се грешка на серверу. Покушајте поново касније.',
    'login.noToken': 'Није примљен токен за аутентификацију са сервера',
    'login.guestLoginFailed': 'Пријављивање госта неуспешно',
    'login.guestLoginTimeout': 'Сервер је предуго одговарао. Покушајте поново.',
    'login.guestLoginNetworkError': 'Није могуће повезати се са сервером. Проверите да ли је позадина покренута.',
    'login.guestLoginUnauthorized': 'Пријављивање госта није ауторизовано. Проверите конфигурацију АПИ кључа.',
    'login.guestLoginNotFound': 'Крајња тачка за пријављивање госта није пронађена. Можда је потребно ажурирање позадине.',
    'login.otpLoginFailed': 'Пријављивање неуспешно након верификације ОТП-а',
    'login.hidePassword': 'Сакриј лозинку',
    'login.showPassword': 'Прикажи лозинку',
    'login.no_account_question': 'Немате налог?',
    'login.with_phone': 'Пријавите се путем телефона',
    'login.with_biometric': 'Пријавите се биометријом',
    'login.provide_email': 'Молимо унесите email',
    'login.provide_pass': 'Молимо унесите лозинку',
    'login.input_placeholder': 'Унесите корисничко име, е-пошту или телефон',
  },
  fr: {
    'login.backToHome': 'Retour à l\'accueil',
    'login.usernameOrEmailRequired': 'Le nom d\'utilisateur ou l\'email est requis',
    'login.passwordRequired': 'Le mot de passe est requis',
    'login.loginFailed': 'Échec de la connexion',
    'login.invalidCredentials': 'Nom d\'utilisateur/email ou mot de passe invalide',
    'login.networkError': 'Impossible de se connecter au serveur. Veuillez vérifier votre connexion et réessayer.',
    'login.timeout': 'La demande de connexion a expiré. Veuillez réessayer.',
    'login.serverError': 'Une erreur serveur s\'est produite. Veuillez réessayer plus tard.',
    'login.noToken': 'Aucun token d\'authentification reçu du serveur',
    'login.guestLoginFailed': 'Échec de la connexion invité',
    'login.guestLoginTimeout': 'Le serveur a pris trop de temps à répondre. Veuillez réessayer.',
    'login.guestLoginNetworkError': 'Impossible de se connecter au serveur. Veuillez vérifier si le backend est en cours d\'exécution.',
    'login.guestLoginUnauthorized': 'La connexion invité n\'est pas autorisée. Vérifiez la configuration de la clé API.',
    'login.guestLoginNotFound': 'Point de terminaison de connexion invité introuvable. Le backend peut nécessiter une mise à jour.',
    'login.otpLoginFailed': 'Échec de la connexion après vérification OTP',
    'login.hidePassword': 'Masquer le mot de passe',
    'login.showPassword': 'Afficher le mot de passe',
    'login.no_account_question': 'Vous n\'avez pas de compte ?',
    'login.with_phone': 'Se connecter avec le téléphone',
    'login.with_biometric': 'Se connecter avec biométrie',
    'login.provide_email': 'Veuillez fournir un email',
    'login.provide_pass': 'Veuillez fournir un mot de passe',
    'login.input_placeholder': 'Entrez nom d\'utilisateur, email ou téléphone',
  },
  sq: {
    'login.backToHome': 'Kthehu në shtëpi',
    'login.usernameOrEmailRequired': 'Emri i përdoruesit ose emaili është i nevojshëm',
    'login.passwordRequired': 'Fjalëkalimi është i nevojshëm',
    'login.loginFailed': 'Hyrja dështoi',
    'login.invalidCredentials': 'Emri i përdoruesit/email ose fjalëkalimi është i pavlefshëm',
    'login.networkError': 'Nuk mund të lidhet me serverin. Ju lutem kontrolloni lidhjen dhe provoni përsëri.',
    'login.timeout': 'Kërkesa për hyrje ka skaduar. Ju lutem provoni përsëri.',
    'login.serverError': 'Ndodhi një gabim në server. Ju lutem provoni përsëri më vonë.',
    'login.noToken': 'Nuk u mor token autentifikimi nga serveri',
    'login.guestLoginFailed': 'Hyrja si mysafir dështoi',
    'login.guestLoginTimeout': 'Serveri mori shumë kohë për t\'u përgjigjur. Ju lutem provoni përsëri.',
    'login.guestLoginNetworkError': 'Nuk mund të lidhet me serverin. Ju lutem kontrolloni nëse backend-i është në ekzekutim.',
    'login.guestLoginUnauthorized': 'Hyrja si mysafir nuk është e autorizuar. Kontrolloni konfigurimin e çelësit API.',
    'login.guestLoginNotFound': 'Pika e fundit e hyrjes si mysafir nuk u gjet. Backend-i mund të ketë nevojë për përditësim.',
    'login.otpLoginFailed': 'Hyrja dështoi pas verifikimit të OTP',
    'login.hidePassword': 'Fshih fjalëkalimin',
    'login.showPassword': 'Shfaq fjalëkalimin',
    'login.no_account_question': 'A nuk keni llogari?',
    'login.with_phone': 'Hyni me numrin e telefonit',
    'login.with_biometric': 'Hyni me biometrik',
    'login.provide_email': 'Ju lutem jepni një email',
    'login.provide_pass': 'Ju lutem jepni një fjalëkalim',
    'login.input_placeholder': 'Votre@email.com o votre_nom_përdoruesit',
  },
  ru: {
    'login.backToHome': 'Вернуться на главную',
    'login.usernameOrEmailRequired': 'Требуется имя пользователя или email',
    'login.passwordRequired': 'Требуется пароль',
    'login.loginFailed': 'Вход не удался',
    'login.invalidCredentials': 'Неверное имя пользователя/email или пароль',
    'login.networkError': 'Не удается подключиться к серверу. Пожалуйста, проверьте подключение и попробуйте снова.',
    'login.timeout': 'Запрос на вход истек. Пожалуйста, попробуйте снова.',
    'login.serverError': 'Произошла ошибка сервера. Пожалуйста, попробуйте позже.',
    'login.noToken': 'Токен аутентификации не получен от сервера',
    'login.guestLoginFailed': 'Вход как гость не удался',
    'login.guestLoginTimeout': 'Сервер слишком долго отвечал. Пожалуйста, попробуйте снова.',
    'login.guestLoginNetworkError': 'Не удается подключиться к серверу. Пожалуйста, проверьте, запущен ли backend.',
    'login.guestLoginUnauthorized': 'Вход как гость не авторизован. Проверьте конфигурацию ключа API.',
    'login.guestLoginNotFound': 'Конечная точка входа как гость не найдена. Backend может потребовать обновления.',
    'login.otpLoginFailed': 'Вход не удался после проверки OTP',
    'login.hidePassword': 'Скрыть пароль',
    'login.showPassword': 'Показать пароль',
    'login.no_account_question': 'Немате налог?',
    'login.with_phone': 'Пријавите се путем телефона',
    'login.with_biometric': 'Пријавите се биометријом',
    'login.provide_email': 'Молимо унесите email',
    'login.provide_pass': 'Молимо унесите лозинку',
    'login.input_placeholder': 'ваш@email.com или ваш_имя_пользователя',
  },
  pt: {
    'login.backToHome': 'Voltar ao Início',
    'login.usernameOrEmailRequired': 'Nome de usuário ou email é obrigatório',
    'login.passwordRequired': 'Senha é obrigatória',
    'login.loginFailed': 'Falha no login',
    'login.invalidCredentials': 'Nome de usuário/email ou senha inválidos',
    'login.networkError': 'Não é possível conectar ao servidor. Por favor, verifique sua conexão e tente novamente.',
    'login.timeout': 'A solicitação de login expirou. Por favor, tente novamente.',
    'login.serverError': 'Ocorreu um erro no servidor. Por favor, tente novamente mais tarde.',
    'login.noToken': 'Nenhum token de autenticação recebido do servidor',
    'login.guestLoginFailed': 'Login de convidado falhou',
    'login.guestLoginTimeout': 'O servidor demorou muito para responder. Por favor, tente novamente.',
    'login.guestLoginNetworkError': 'Não é possível conectar ao servidor. Por favor, verifique se o backend está em execução.',
    'login.guestLoginUnauthorized': 'Login de convidado não está autorizado. Verifique a configuração da chave da API.',
    'login.guestLoginNotFound': 'Endpoint de login de convidado não encontrado. O backend pode precisar de atualização.',
    'login.otpLoginFailed': 'Login falhou após verificação OTP',
    'login.hidePassword': 'Ocultar senha',
    'login.showPassword': 'Mostrar senha',
    'login.no_account_question': 'Não tem uma conta?',
    'login.with_phone': 'Entrar com o número de telefone',
    'login.with_biometric': 'Entrar com biométrica',
    'login.provide_email': 'Por favor, forneça um email',
    'login.provide_pass': 'Por favor, forneça uma senha',
    'login.input_placeholder': 'Digite seu nome de usuário, email ou telefone',
  },
  el: {
    'login.backToHome': 'Επιστροφή στην αρχική σελίδα',
    'login.usernameOrEmailRequired': 'Απαιτείται όνομα χρήστη ή email',
    'login.passwordRequired': 'Απαιτείται κωδικός πρόσβασης',
    'login.loginFailed': 'Η σύνδεση απέτυχε',
    'login.invalidCredentials': 'Μη έγκυρο όνομα χρήστη/email ή κωδικός πρόσβασης',
    'login.networkError': 'Δεν είναι δυνατή η σύνδεση με τον διακομιστή. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
    'login.timeout': 'Το αίτημα σύνδεσης έληξε. Παρακαλώ δοκιμάστε ξανά.',
    'login.serverError': 'Παρουσιάστηκε σφάλμα διακομιστή. Παρακαλώ δοκιμάστε ξανά αργότερα.',
    'login.noToken': 'Δεν ελήφθη διακριτικό πιστοποίησης από τον διακομιστή',
    'login.guestLoginFailed': 'Η σύνδεση ως επισκέπτης απέτυχε',
    'login.guestLoginTimeout': 'Ο διακομιστής χρειάστηκε πολύ χρόνο για να απαντήσει. Παρακαλώ δοκιμάστε ξανά.',
    'login.guestLoginNetworkError': 'Δεν είναι δυνατή η σύνδεση με τον διακομιστή. Ελέγξτε αν το backend εκτελείται.',
    'login.guestLoginUnauthorized': 'Η σύνδεση ως επισκέπτης δεν είναι εξουσιοδοτημένη. Ελέγξτε τη διαμόρφωση του κλειδιού API.',
    'login.guestLoginNotFound': 'Το σημείο τερματισμού σύνδεσης επισκέπτη δεν βρέθηκε. Το backend μπορεί να χρειάζεται ενημέρωση.',
    'login.otpLoginFailed': 'Η σύνδεση απέτυχε μετά την επαλήθευση OTP',
    'login.hidePassword': 'Απόκρυψη κωδικού πρόσβασης',
    'login.showPassword': 'Εμφάνιση κωδικού πρόσβασης',
    'login.no_account_question': 'Δεν έχετε λογαριασμό;',
    'login.with_phone': 'Σύνδεση με τηλέφωνο',
    'login.with_biometric': 'Σύνδεση με βιομετρικά',
    'login.provide_email': 'Παρακαλώ δώστε ένα email',
    'login.provide_pass': 'Παρακαλώ δώστε έναν κωδικό πρόσβασης',
    'login.input_placeholder': 'Εισαγάγετε όνομα χρήστη, email ή τηλέφωνο',
  },
  de: {
    'login.backToHome': 'Zurück zur Startseite',
    'login.usernameOrEmailRequired': 'Benutzername oder E-Mail ist erforderlich',
    'login.passwordRequired': 'Passwort ist erforderlich',
    'login.loginFailed': 'Anmeldung fehlgeschlagen',
    'login.invalidCredentials': 'Ungültiger Benutzername/E-Mail oder Passwort',
    'login.networkError': 'Verbindung zum Server nicht möglich. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    'login.timeout': 'Die Anmeldeanfrage ist abgelaufen. Bitte versuchen Sie es erneut.',
    'login.serverError': 'Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
    'login.noToken': 'Kein Authentifizierungstoken vom Server erhalten',
    'login.guestLoginFailed': 'Gast-Anmeldung fehlgeschlagen',
    'login.guestLoginTimeout': 'Der Server hat zu lange zum Antworten gebraucht. Bitte versuchen Sie es erneut.',
    'login.guestLoginNetworkError': 'Verbindung zum Server nicht möglich. Bitte überprüfen Sie, ob das Backend läuft.',
    'login.guestLoginUnauthorized': 'Gast-Anmeldung ist nicht autorisiert. Überprüfen Sie die API-Schlüssel-Konfiguration.',
    'login.guestLoginNotFound': 'Gast-Anmelde-Endpunkt nicht gefunden. Das Backend muss möglicherweise aktualisiert werden.',
    'login.otpLoginFailed': 'Anmeldung nach OTP-Verifizierung fehlgeschlagen',
    'login.hidePassword': 'Passwort ausblenden',
    'login.showPassword': 'Passwort anzeigen',
    'login.no_account_question': 'Haben Sie kein Konto?',
    'login.with_phone': 'Mit Telefon anmelden',
    'login.with_biometric': 'Mit Biometrie anmelden',
    'login.provide_email': 'Bitte geben Sie eine E-Mail an',
    'login.provide_pass': 'Bitte geben Sie ein Passwort an',
    'login.input_placeholder': 'Geben Sie Benutzername, E-Mail oder Telefon ein',
  },
  ro: {
    'login.backToHome': 'Înapoi la pagina principală',
    'login.usernameOrEmailRequired': 'Numele de utilizator sau email este obligatoriu',
    'login.passwordRequired': 'Parola este obligatorie',
    'login.loginFailed': 'Autentificare eșuată',
    'login.invalidCredentials': 'Nume de utilizator/email sau parolă invalidă',
    'login.networkError': 'Nu se poate conecta la server. Verificați conexiunea și încercați din nou.',
    'login.timeout': 'Solicitarea de autentificare a expirat. Încercați din nou.',
    'login.serverError': 'A apărut o eroare pe server. Încercați din nou mai târziu.',
    'login.noToken': 'Nu s-a primit niciun token de autentificare de la server',
    'login.guestLoginFailed': 'Autentificarea ca vizitator a eșuat',
    'login.guestLoginTimeout': 'Serverul a răspuns prea lent. Încercați din nou.',
    'login.guestLoginNetworkError': 'Nu se poate conecta la server. Verificați dacă backend-ul este pornit.',
    'login.guestLoginUnauthorized': 'Autentificarea ca vizitator nu este autorizată. Verificați configurarea cheii API.',
    'login.guestLoginNotFound': 'Endpointul de autentificare ca vizitator nu a fost găsit. Backend-ul ar putea necesita o actualizare.',
    'login.otpLoginFailed': 'Autentificare eșuată după verificarea OTP',
    'login.hidePassword': 'Ascunde parola',
    'login.showPassword': 'Arată parola',
    'login.no_account_question': 'Nu ai cont?',
    'login.with_phone': 'Conectează-te cu telefonul',
    'login.with_biometric': 'Conectează-te cu biometria',
    'login.provide_email': 'Te rugăm să furnizezi un email',
    'login.provide_pass': 'Te rugăm să furnizezi o parolă',
    'login.input_placeholder': 'Introdu numele de utilizator, email sau telefon',
  },
  pl: {
    'login.backToHome': 'Powrót do Strony Głównej',
    'login.usernameOrEmailRequired': 'Wymagana jest nazwa użytkownika lub email',
    'login.passwordRequired': 'Wymagane jest hasło',
    'login.loginFailed': 'Logowanie nie powiodło się',
    'login.invalidCredentials': 'Nieprawidłowa nazwa użytkownika/email lub hasło',
    'login.networkError': 'Nie można połączyć się z serwerem. Sprawdź połączenie i spróbuj ponownie.',
    'login.timeout': 'Żądanie logowania wygasło. Spróbuj ponownie.',
    'login.serverError': 'Wystąpił błąd serwera. Spróbuj ponownie później.',
    'login.noToken': 'Nie otrzymano tokenu uwierzytelniania z serwera',
    'login.guestLoginFailed': 'Logowanie gościa nie powiodło się',
    'login.guestLoginTimeout': 'Serwer zbyt długo odpowiadał. Spróbuj ponownie.',
    'login.guestLoginNetworkError': 'Nie można połączyć się z serwerem. Sprawdź, czy backend jest uruchomiony.',
    'login.guestLoginUnauthorized': 'Logowanie gościa nie jest autoryzowane. Sprawdź konfigurację klucza API.',
    'login.guestLoginNotFound': 'Endpoint logowania gościa nie znaleziony. Backend może wymagać aktualizacji.',
    'login.otpLoginFailed': 'Logowanie nie powiodło się po weryfikacji OTP',
    'login.hidePassword': 'Ukryj hasło',
    'login.showPassword': 'Pokaż hasło',
    'login.no_account_question': 'Nie masz konta?',
    'login.with_phone': 'Zaloguj się przez telefon',
    'login.with_biometric': 'Zaloguj się biometrycznie',
    'login.provide_email': 'Proszę podać adres email',
    'login.provide_pass': 'Proszę podać hasło',
    'login.input_placeholder': 'Wprowadź nazwę użytkownika, email lub telefon',
  },
};                        